import { SyncOutlined } from '@ant-design/icons';
import { Space, Tooltip } from 'antd';
import DatePickerField from 'components/Global/DatePicker';
import styles from './index.module.scss';

type Props = {
	dateValue: any;
	handleDatePicker: any;
	isLoading: any;
	fetchTimeSheets: any;
};

const TimeSheetsTableHeader = (props: Props) => {
	const {
		handleDatePicker,
		dateValue,
		isLoading,
		fetchTimeSheets,
	} = props;

	return (
		<div className={styles['employee-header']}>
			<Space>
				<DatePickerField
					name={'dateFilter'}
					value={dateValue}
					required={false}
					picker="month"
					isError={false}
					onChange={handleDatePicker}
				/>
			</Space>
			<div className={styles['employee-header__buttons']}>
				<Tooltip title="Refresh all the Time Sheets">
					<SyncOutlined
						style={{
							fontSize: '20px',
							cursor: isLoading ? 'not-allowed' : 'pointer',
							color: '#584495',
							transition: 'transform 0.3s',
							marginRight: '10px',
						}}
						onClick={!isLoading ? fetchTimeSheets : undefined}
					/>
				</Tooltip>
			</div>
		</div>
	);
};

export default TimeSheetsTableHeader;
